import qs from "qs";

export const isTouchDevice = "ontouchstart" in document.documentElement;

export const isIos =
    /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const generateUrl = (form, data = {}, selectedQuery, queryName, replaceParams = false, replace = true) => {
    let params = data;

    if (data instanceof FormData === true) {
        params = {};
        data.forEach((value, key) => {
            params[key] = value;
        });
    }

    // Parse the existing URL and query parameters
    const url = new URL(form.action);
    const currentParams = qs.parse(url.search, { ignoreQueryPrefix: true });

    delete currentParams.view;
    delete currentParams.sort;
    delete currentParams.zip;
    delete currentParams.service;
    delete currentParams.practice;
    delete currentParams.page;
    delete currentParams.resultsPerPage;
    delete currentParams.pageCount;

    delete params.pageCount;

    // // Merge the remaining query parameters with the new ones
    const newParams = { ...currentParams };

    Object.keys(params).forEach((key) => {
        if (newParams[key] && replaceParams === false) {
            const newValue = params[key];
            if (!newParams[key].includes(newValue)) {
                newParams[key] += `,${newValue}`;
            } else {
                if (selectedQuery && newParams[key].includes(selectedQuery)) {
                    newParams[queryName] = newParams[queryName].split(",").filter((value) => value !== selectedQuery).join(",");
                }
            }
        } else {
            newParams[key] = params[key];
        }
    });

    // Serialize the parameters into a query string
    const query = qs.stringify(newParams, { arrayFormat: "comma", filter: (_, value) => value || undefined });
    const queryStr = query ? `?${query}` : "";

    // Set the updated query string to the URL
    url.search = queryStr;

    if (replace) {
        return url.toString();
    } else {
        return `${form.action}${queryStr}`;
    }
};

export const handleModalCheckedClass = (param) => {
    let paramsArray = [];

    if (typeof param === 'string') {
        paramsArray = param.split(',');
    } else if (Array.isArray(param)) {
        paramsArray = param;
    } else if (typeof param === 'object' && param !== null) {
        paramsArray = Object.keys(param);
    }

    const combinedString = paramsArray.join(' ');
    const paramCount = combinedString.split(' ').length;

    if (paramCount > 0) {
        Object.keys(param).forEach((key) => {
            const paramValue = param.split(',');

            paramValue.forEach(value => {
                const checkbox = document.querySelector(`.modal-filter[value="${value}"]`);

                if (checkbox) {
                    checkbox.classList.add('checked');
                }

                // Handle related categories active state
                const relatedCategoriesContainer = document.querySelector(`[data-related-container="${value}"]`);
                if (relatedCategoriesContainer) {
                    if (checkbox.classList.contains('checked')) {
                        relatedCategoriesContainer.classList.add('pill-fill-active');
                    } else {
                        relatedCategoriesContainer.classList.remove('pill-fill-active');
                    }
                }

            });
        });
    } else {
        const paramValue = typeof param === 'string' ? param : paramsArray[0];
        const checkbox = document.querySelector(`.modal-filter[value="${paramValue}"]`);

        if (!checkbox) {
            return;
        }

        checkbox.classList.add('checked');
    }
}

export const trackGoogleAnalytics = (event) => {
    if (window.dataLayer) {
      window.dataLayer.push(event)
    }
  }
